import { type ApiContainerAction } from '@Model';
import {
    type AsyncStateUpdate,
    TextInput,
    useGuiBinder,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';

interface ContainerRemarksCellProps {
    action: ApiContainerAction;
    canEdit: boolean;
    requestUpdateState: AsyncStateUpdate<ApiContainerAction>;
    /** Names the row inside a line of two, such as "Bemerkung Raus". */
    label?: string;
}

/** The remark the planner noted for one row. */
// @ai-generated 2026-10-28T13:39:59+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ContainerRemarksCell({ action, canEdit, requestUpdateState, label }: ContainerRemarksCellProps) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiContainerAction>({
        data: action,
        meta: undefined,
        canEdit,
        requestUpdateState,
    });
    const remarksField = useProp(binder, 'remarks');

    return <TextInput {...remarksField} label={label ?? i18n('Bemerkung')} />;
}
